import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { Switch, useLocation } from 'react-router-dom';

const CoreRouter = ({ children }) => {
  const { isSnackbar } = useSelector((state) => state.data);
  const { pathname } = useLocation();

  const message = isSnackbar?.message;
  const variant = isSnackbar?.variant;

  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (message && variant) {
      enqueueSnackbar(message, { variant });
    }
  }, [message, variant, enqueueSnackbar]);

  useEffect(() => {
    window.scroll(0, 0);
  }, [pathname]);

  return <Switch>{children}</Switch>;
};

export default CoreRouter;
